module.exports = __webpack_public_path__ + "img/5 huevo.952cd55e.jpg";